import { MouseEvent } from 'react';
import cls from 'classnames';
import Link from 'next/link';

import { getCategoryHref } from '../../../utils/common/category';

import { SubcategoriesProps } from './types';
import { useStyles } from './styles';

function Subcategories({
  items,
  isExpanded,
  selectedMenuCategoryType,
  setMenuSelectedItem,
  selectedMenuSubcategory,
  ownCategoryType,
}: SubcategoriesProps) {
  const classes = useStyles();

  return (
    <ul className={cls(classes.subcategories, isExpanded && 'MenuSubcategoriesVisible')}>
      {items.map(({ category, text }, i) => {
        const isSelected =
          ownCategoryType === selectedMenuCategoryType && selectedMenuSubcategory === category;

        return (
          <li
            onClick={(e: MouseEvent<Element>) => {
              e.stopPropagation();

              setMenuSelectedItem({
                selectedMenuCategoryType: ownCategoryType,
                selectedMenuSubcategory: category,
              });
            }}
            key={`${text}${category}${i}`}
          >
            <Link href={getCategoryHref(category)}>
              <a className={cls(classes.subcategory, isSelected && classes.selected)}>{text}</a>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

export default Subcategories;
